import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";

// Contexts
import DomainContext from "../../../context/domains/DomainContext";

const DomainRemoveBox = ({ open_remove_box, closeRemoveBox, remove }) => {
  const { projects, selected_domain } = useContext(DomainContext);

  const [domain_name, setDomainName] = useState("");
  const [project_name, setProjectName] = useState("");

  useEffect(() => {
    if (open_remove_box && selected_domain) {
      let project = "";

      for (let x in projects) {
        if (projects[x].id === selected_domain.projectId) {
          project = projects[x].name;
          break;
        }
      }

      setDomainName(selected_domain.name);
      setProjectName(project);
    }
  });

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={open_remove_box}
      onClose={(e, reason) => {
        if (!["backdropClick", "escapeKeyDown"].includes(reason))
          closeRemoveBox();
      }}
    >
      <DialogTitle align="center"> Remove Domain from Project </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Would you like to remove the domain <strong> {domain_name} </strong>{" "}
          from your project <strong> {project_name} </strong>?{" "}
        </Typography>
        <br />
        <Typography variant="body1" gutterBottom>
          After continuing, your project will no longer be accessible through
          this domain.{" "}
        </Typography>{" "}
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="center">
          <Grid item xs={6} align="center">
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="default"
              onClick={() => closeRemoveBox()}
            >
              Cancel{" "}
            </Button>{" "}
          </Grid>
          <Grid item xs={6} align="center">
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              onClick={() => remove()}
            >
              Remove{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default DomainRemoveBox;
